module.exports = __webpack_public_path__ + "static/so-good-they-cant-ignore-you-b5c801fec14c8a4452f8a80dc75fbe6a.jpg";